import React from 'react'
import pt from 'prop-types'
import { Field } from 'formik'
import RadioGroup from '@/components/controls/RadioGroup'

const RadioGroupField = ({ label, ...ownProps }) => (
  <Field {...ownProps}>
    {({ field, form }) => {
      const { isSubmitting } = form

      const onChange = (value) => {
        form.setFieldValue(field.name, value)
      }

      return (
        <RadioGroup
          {...ownProps}
          {...field}
          onChange={onChange}
          label={label}
          disabled={isSubmitting}
        />
      )
    }}
  </Field>
)

RadioGroupField.defaultProps = {
  label: null,
}

RadioGroupField.propTypes = {
  label: pt.oneOfType([pt.string, pt.element]),
}

export default React.memo(RadioGroupField)
